// Copyright (c) 2018 Deere & Company

import * as busyCounter from '../../../shared/action-creators/busy-counter';
import actions from '../actions-list';
import {deleteFile as deleteFileRepo} from '../../../product/shared/repositories';
import {getDefaultState as getFileDefaultState} from '@deere/cps-it.warranty-model-factory/lib/file';
export const deleteFile = fileToDelete =>

    async dispatch => {

        dispatch(busyCounter.increaseBusyCounter());

        try {

            await deleteFileRepo(fileToDelete);

            dispatch({
                file: getFileDefaultState(),
                type: actions.UPDATE_MASS_LABOR_RATE_FILE
            });

        } catch (error) {

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };



// WEBPACK FOOTER //
// ./src/claim/mass-labor-rate-change/action-creators/delete-file.js